<template>
  <div class="container-xl">

    <div class="hade">
      <router-link to="/about"
        ><img
          src="../img/button icon@2x2.png"
          alt=""
        />&nbsp;预约口腔扫描</router-link
      >
    </div>
    <div class="row">
      <div class="step">
        <img src="../img/Group71652x.png" alt="" /><br />
        <span>选择诊所</span>
        <span>日期时间</span>
        <span>联络资料</span>
      </div>
      <div class="col-lg-12 calendar">
        <div class="input">
          <van-field
            v-model="userName"
            label="姓名"
            placeholder="请输入用户名"
          />
          <van-radio-group v-model="sex" direction="horizontal">
            性别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
            <van-radio name="隐藏">隐藏</van-radio>
          </van-radio-group>
          <van-field
            v-model="userPhone"
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
          />
<!--          <van-field v-model="mail" label="邮箱" placeholder="请输入邮箱" />-->
          <p style="margin-top: 40px; margin-bottom: 20px">
            <input
              type="checkbox"
              checked="checked"
              style="margin-right: 5px"
            />
            订阅 be@me，随时获取最新消息
          </p>
          <button style="cursor: pointer" @click="kap1()">下一步</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {

  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/liaison'
    },{
      rel:'alternate',
      href:'https://mybeame.com/liaison',
      hrefLang:'x-default'
    }
    ]
  },
  data() {
    return {
      userName: "",
      userPhone: "",
      mail: "",
      sex: "",
      showPicker: false,
      value: "86",
    };
  },
  methods: {
    
    //验证 储存信息
    kap1: function () {
      if (this.userName == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning",
        });
        return;
      }


      if (/^[0-9]\d{4,10}$/.test(this.userPhone) == false) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning",
        });
        return;
      }

      // if (
      //   /^([a-zA-Z0-9_\.\-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
      //     this.mail
      //   ) == false
      // ) {
      //   this.$message({
      //     message: "邮箱格式不正确",
      //     type: "warning",
      //   });
      //   return;
      // }
      var liaison = {
        userName: this.userName,
        userPhone: this.value + this.userPhone,
        mail: this.mail,
        sex: this.sex,
      };
      localStorage.setItem("liaison", JSON.stringify(liaison));
      this.$router.push("/screenshot");
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin: 0;
  background-color: #f2f2f2;
}
.hade {
  width: 100%;
  padding: 10px 0;
  margin-top: 50px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
}
.hade > a {
  margin-left: 20px;
  font-weight: 700;
  display: flex;
  font-size: 19px;
}
.hade > a > img {
  width: 17px;
  height: 29px;
}

.step {
  font-size: 19px;
  text-align: center;
  background-color: #f2f2f2;
  margin-bottom: 20px;
}
.step > img {
  margin: 20px 0 12px 0;
}
.step > span {
  font-weight: 700;
}
.step span:nth-child(4) {
  margin: 0 158px;
}
.input {
  text-align: center;
}
.van-cell {
  width: 40%;
  border: 2px solid #00e467;
  border-radius: 10px;
  margin: auto;
  margin-top: 20px;
}
.area {
  width: 40%;
  height: 48px;
  padding-left: 1%;
  background-color: #fff;
  border-radius: 10px;
  margin: auto;
  margin-top: 20px;
  border: 2px solid #00e467;
  text-align: left;
  font-weight: 700;
}
.area >>> .el-input {
  width: 90%;
}
.input > p {
  margin-top: 40px;
  display: flex;
  margin: auto;
  width: 260px;
}
.input > p > input {
  width: 16px;
  height: 22px;
  margin: 0;
}
.input > button {
  width: 40%;
  font-size: 18px;
  font-weight: 700;
  padding: 11px 0 11px 0;
  margin-bottom: 100px;
  border: none;
  background: #00e467;
  border-radius: 0px 10px 0px 0px;
}
.van-radio-group--horizontal {
  margin: 0 auto;
  width: 40%;
  margin-top: 20px;
  border: 2px solid #00e467;
  border-radius: 10px;
  padding: 12px 10px;
  font-size: 16px;
  background-color: #fff;
  font-weight: 700;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
  .hade {
    width: 100%;
    padding: 10px 0;
    background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  }
  .hade > a {
    margin-left: 20px;
    font-weight: 700;
    display: flex;
    font-size: 19px;
  }
  .hade > a img:nth-child(1) {
    width: 14px;
    height: 26px;
  }
  .hade > a img:nth-child(2) {
    width: 20px;
    height: 22px;
    margin-right: 2px;
    padding-bottom: 2px;
  }
  .step {
    text-align: center;
  }
  .step > img {
    margin: 20px 0 12px 0;
    width: 249px;
    height: 16px;
  }
  .step > span {
    font-weight: 700;
  }
  .step span:nth-child(4) {
    margin: 0 52px;
  }
  .input {
    text-align: center;
  }
  .van-cell {
    width: 90%;
    border: 2px solid #00e467;
    border-radius: 10px;
    margin: auto;
    margin-top: 20px;
  }

  .input > p {
    margin-top: 40px;
    display: flex;
    margin: auto;
    width: 260px;
  }
  .input > p > input {
    width: 16px;
    height: 22px;
    margin: 0;
  }
  .input > button {
    width: 90%;
    font-size: 18px;
    font-weight: 700;
    padding: 11px 0 11px 0;
    margin-bottom: 100px;
    border: none;
    background: #00e467;
    border-radius: 0px 10px 0px 0px;
  }
  .van-radio-group--horizontal {
    margin: 0 auto;
    width: 90%;
    margin-top: 20px;
    border: 2px solid #00e467;
    border-radius: 10px;
    padding: 12px 10px;
    font-size: 15px;
    font-weight: 700;
  }
  .area {
    width: 90%;
    font-size: 15px;
    padding-left: 3%;
  }
  .area >>> .el-input {
    font-size: 15px !important;
    padding-right: 0 !important;
  }
  .hade {
    margin-top: 0;
  }
   .row {
    background-color: #fff;
  }
  .step {
    background-color: #fff;
  }
}
@media all and (max-width: 570px) {
 
  .hade > a > img {
    width: 16px;
    height: 29px;
  }
  .hade > a {
    font-size: 18px;
  }
  .step > span {
    font-size: 15px;
  }
}
</style>